<div class="message-confirm" *ngIf="isDeliveryConfirmation">
  <h2 class="title">Дякуємо!</h2>
  <b>
    Ваше замовлення № {{ data.data.order_id }} прийняте
  </b>
  <b class="alert">
    При необхідності ви можете зробити дозаказ до {{ data.data.tiltime }} дня доставки.<br>
    <ng-container *ngIf="user.del_cost > 0">
      Якщо сума замовлення з дозаказом перевищує {{ data.data.del_summa2 }} грн - вартість доставки автоматично стане
      безкоштовною.
    </ng-container>
  </b>
  <p class="text-center">Оформлене замовлення <span class="alert">до {{ data.data.tiltime }} </span> відправляється в
    <span class="alert">той же день</span>
  </p>
  <p class="text-center">Замовлення оформлені <span class="alert">після {{ data.data.tiltime }} </span> будуть
    відправлені <span class="alert">наступного робочого дня</span>
  </p>
  <div class="row items-center form_data"
       *ngIf="parseFloat(data.data.calcdebt_summa) > 1 && (
                    parseFloat(data.data.calcdebt_summa) > parseFloat(data.data.delay_summa)
                    || data.data.delay_from && (data.data.delay_from < data.data.delay_days)
              )"
  >
    <div class="column"></div>
    <div class="column shrink textright">
      <b class="comment">
        Прострочена заборгованість!<br>
        Відвантаження вашого замовлення можливе після виконання договірних зобов'язань щодо оплати.
      </b>
    </div>
    <div class="column"></div>
  </div>

  <a routerLink="/account" class="button">Ознайомлений</a>
</div>

